module.exports = __webpack_public_path__ + "img/LogoGiveAndGet.f008fcad.svg";